const translate = {
    rating_button_text: 'Oceń samochód',
    not_rated_yet: 'Nikt jeszcze nie ocenił. Dodaj pierwszą ocenę!',
    rating_count: 'Liczba opinii: ',
    rated_text: 'Dziękujemy! Twoja ocena to:'
};

export default translate;
